import { Injectable } from '@angular/core';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
import * as highcharts from 'highcharts/highstock';

@Injectable()
export class HighchartsService {

    /** Instâncias de gráficos sob constrole do serviço */
    private chartsInstances: any[] = [];
    private defaultOptions: any;
    private reseted: boolean;

    constructor(
        private utilitiesService: UtilitiesService,
    ) {
        // Evita que a tooltip do gráfico seja escondida após o foco do mouse sair da região do gráfico
        ((H) => {
            H.wrap(H.Tooltip.prototype, 'hide', (defaultCallback: any) => {/**/});
        })(highcharts);
    }

    /**
     * Plota um novo gráfico no container fornecido
     * @param targetContainer Container que receberá o elemento gráfico
     * @param series Dados do gráfico
     * @param categories Categorias xasis
     * @param plotOptions Opções de plotagem da api do Highcharts
     * @param tooltipFormatter Formatação do Tooltip
     * @param heightChart Tamanho do gráfico (padrão null)
     * @param crosshairChart Acrescenta crosshair no gráfico (padrão true)
     * @param tooltipFormatterBigger Tamanho do tooltip grande do padrão do HUB (padrão true)
     * @param labelAlignX Alinhamento do label da linha x (padrão left)
     */
    public plotLineChart(
        targetContainer,
        series,
        categories,
        plotOptions,
        tooltipFormatter,
        heightChart= null,
        crosshairChart = true,
        tooltipFormatterBigger = true,
        labelAlignX = 'left',
    ): any {

        const wraper = $(targetContainer)
            .find('.chart-wraper')[0];
        const softMax = series[0].data[series.length - 1] * 1.2;
        const instanceId = this.utilitiesService.guid();
        // tslint:disable-next-line: prefer-const
        let options = this.getPlotLineChartOptions(
            softMax,
            categories,
            series,
            tooltipFormatter,
            plotOptions.darkTheme,
            heightChart,
            crosshairChart,
            tooltipFormatterBigger,
            labelAlignX,
        );

        // update render to option
        if (!!options.chart) {
            // tslint:disable-next-line: no-string-literal
            options.chart['renderTo'] = wraper;
        } else {
            options.chart = {
                renderTo: wraper,
            } as any;
        }

        // plot and save the chart
        const instance = {
            id: instanceId,
            instance: new highcharts.Chart(options),
        };
        this.chartsInstances.push(instance);

        return instance;
    }

    /**
     * Remove um gráfico
     * @param instanceId Id da instância a ser removida
     */
    public removeChart(instanceId: string) {
        for (let i = 0; i < this.chartsInstances.length; i++) {
            if (this.chartsInstances[i].id === instanceId) {
                this.chartsInstances.splice(i, 1);
                break;
            }
        }
    }

    /** Onload handler */
    public onChartLoad() {
        return function() {
            // tslint:disable-next-line: prefer-const
            let pointsToRefresh = [];
            // tslint:disable-next-line: prefer-for-of
            for (let index = 0; index < this.series.length; index++) {
                pointsToRefresh.push(this.series[index].points[this.series[index].points.length - 1]);
            }

            this.tooltip.refresh(pointsToRefresh);
            let mouseOver = false;
            // tslint:disable-next-line: prefer-const
            let graphic = this;
            $(this.container)
                .mouseover(() => {
                if (!mouseOver) {
                    mouseOver = true;
                    graphic.series[0].xAxis.plotLinesAndBands[0].destroy();
                }
            });
        };
    }

    /** Definições padrão do gráfico de linha  */
    public getPlotLineChartOptions(
        softMaxGraphic,
        categoriesGraphic,
        seriesGraphic,
        tooltipFormatter,
        darkTheme = true,
        heightChart = null,
        crosshairChart = true,
        tooltipFormatterBigger = true,
        labelAlignX = 'left',
    ) {

        // Position of the tooltip
        const detailsPageOffsetTooltip = ( !this.reseted ) ? 0 : 8;

        // tslint:disable-next-line: prefer-const
        let chartOptions = {
            chart: {
                backgroundColor: 'transparent',
                align: 'left',
                verticalAlign: 'top',
                marginLeft: 0,
                redraw: true,
                height: heightChart,
                spacing: [0, 8, 16, 0],
                events: {
                    load: this.onChartLoad(),
                },
            },
            title: {
                text: '',
            },
            subtitle: {
                text: '',
            },
            xAxis: {
                categories: categoriesGraphic,
                crosshair: null,
                plotLines: [{
                    id: 'initial-crosshair',
                    value: 10,
                    width: 3,
                    color: (darkTheme) ? 'rgba(255, 255, 255, 0.5)' : '#899198',
                }],
                labels: {
                    distance: 0,
                    crop: false,
                    useHTML: true,
                    style: {
                        color: (darkTheme) ? '#FFFFFF' : '#082534',
                        fontSize: '14px',
                        paddingTop: '24px',
                    },
                },
                lineColor: '#ccd6eb',
                maxPadding: 0,
                minPadding: 0,
                offset: 16,
                overflow: 'justify',
                tickColor: (darkTheme) ? '#FFFFFF' : '#7E868E',
                tickInterval: 1,
                tickLength: 16,
                tickWidth: 2,
                title: {
                    text: '',
                },
            },
            yAxis: [{
                allowDecimals: true,
                gridLineColor: (darkTheme) ? '#FFFFFF' : '#899198',
                // gridLineDashStyle: 'Solid',
                gridLineWidth: 10,
                labels: {
                    enabled: false,
                },
                maxPadding: 0.1,
                minPadding: 0.06,
                minRange: 0.1,
                offset: 0,
                showFirstLabel: false,
                startOnTick: false,
                title: {
                    text: null,
                },
            }],
            legend: {
                enabled: false,
            },
            tooltip: null,
            plotOptions: {
                series: {
                    lineWidth: 2,
                    groupPadding: 0,
                    marker: {
                        enabled: false,
                        states: {
                            hover: {
                                enabled: false,
                            },
                            select: {
                                enabled: false,
                            },
                        },
                    },
                },
            },
            series: seriesGraphic,
        };

        if (heightChart) {
            chartOptions.chart.height = heightChart;
        }

        if (crosshairChart) {
            chartOptions.xAxis.crosshair = {
                width: 2,
                color: (darkTheme) ? 'rgba(255, 255, 255, 0.5)' : '#899198',
                zIndex: 2,
                className: 'crosshair-ball',
            };
        }

        if (tooltipFormatterBigger) {
            chartOptions.tooltip = {
                borderWidth: 1,
                backgroundColor: 'rgba(255,255,255,0)',
                followPointer: false,
                borderRadius: 0,
                borderColor: 'rgba(255,255,255,0)',
                formatter: tooltipFormatter,
                padding: 0,
                positioner: (boxWidth, boxHeight, point) => {
                    let xCalc: number = 0;
                    if (point.plotX <= boxWidth) {
                        xCalc = (point.plotX + 16);
                    } else {
                        xCalc = ((point.plotX - 16) - boxWidth);
                    }
                    let yCalc: number = 0;
                    if (point.plotY <= boxHeight) {
                        yCalc = (point.plotY - 16);
                    } else {
                        yCalc = ((point.plotY - 8) - boxHeight) - detailsPageOffsetTooltip;
                    }

                    return { x: xCalc, y: yCalc };
                },
                shared: true,
                distance: 8,
                shadow: false,
                shape: 'square',
                style: { fontFamily: 'Roboto',
                         strokeWidth: 0,
                        },
                useHTML: true,
            };
        } else {
            chartOptions.tooltip = {
                borderWidth: 0,
                followPointer: false,
                formatter: tooltipFormatter,
                shared: true,
                shadow: false,
                shape: 'square',
                style: { fontFamily: 'Roboto',
                    strokeWidth: 0,
                },
                useHTML: true,
            };
        }

        return chartOptions;
    }

}
